// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "terminal-H18WS";
export { _1 as "__esModule", _2 as "terminal" }
export default { "__esModule": _1, "terminal": _2 }
